jQuery(document).ready(function ($) {
    const sectors = new Swiper('.our-sectors__carousel', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 60,

        pagination: {
            el: '.our-sectors__carousel--pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: true,
        delay: 8000,
        speed: 500,

        grabCursor: true,

        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    });
});